__turbopack_context__.v({
  "container": "Footer-module-scss-module__JLT4gq__container",
  "firstLine": "Footer-module-scss-module__JLT4gq__firstLine",
  "footer": "Footer-module-scss-module__JLT4gq__footer",
  "links": "Footer-module-scss-module__JLT4gq__links",
  "logo": "Footer-module-scss-module__JLT4gq__logo",
  "macpaw": "Footer-module-scss-module__JLT4gq__macpaw",
  "secondLine": "Footer-module-scss-module__JLT4gq__secondLine",
});
